import React from 'react';
import styles from '../../styles.css';
import subIndicatorsStyles from './styles.css';
import { default as SubSubIndicators } from '../SubSubIndicators/index.jsx';

import { isSearchedPhrase } from '../../utils';
import HighlightText from '../../HighlightText.jsx';
import indicatorsStyles from '../Indicators/styles.css';

const hasSelectedDescendants = (item, selectedSubjects) => {
	if (!item.childrens) return false;
	return item.childrens.some(
		(child) => selectedSubjects.includes(child.id) || hasSelectedDescendants(child, selectedSubjects),
	);
};

export default function SubIndicators({
	subIndicators,
	indicatorId,
	nestedListsToShow,
	showNestedLists,
	selectedSubjects,
	onSubjectSelect,
	subjectColor,
	isSimplifiedView,
	subjectParent,
	queryParams,
	searchPhrase,
	onSubjectChange,
}) {
	return (
		<ul
			className={`${styles.subIndicatorsList} ${subIndicatorsStyles.subIndicatorsTree} ${!nestedListsToShow.includes(indicatorId) ? styles.hidden : ''}`}
		>
			{subIndicators.map((subIndicator, index) => {
				let disableExpandButton = false;

				let subjectWithNoChildren = false;

				let subjectsGroup = [];

				const getSubjectChildrens = (childrens) => {
					childrens.forEach((child) => {
						if (child.childrens) {
							getSubjectChildrens(child.childrens);
						}
						subjectsGroup.push(child.fullName);
					});
				};

				subIndicator.childrens ? getSubjectChildrens(subIndicator.childrens) : (subjectWithNoChildren = true);

				const descendantsSelected = !isSimplifiedView && hasSelectedDescendants(subIndicator, selectedSubjects);

				subjectsGroup.forEach((children) => {
					if (
						isSearchedPhrase({
							subjectName: children,
							phrase: searchPhrase,
						})
					) {
						disableExpandButton = true;
					}
				});

				return (
					<li
						key={`${subIndicator.fullName.split(' ').join('')}_${index}`}
						className={`${subIndicatorsStyles.subIndicatorItem} ${
							!isSimplifiedView && selectedSubjects.includes(subIndicator.id)
								? `${subIndicatorsStyles.subIndicatorItemSelected} ${subjectParent}`
								: ''
						}`}
					>
						<a
							onClick={(e) => {
								if (isSimplifiedView && onSubjectChange) {
									e.preventDefault();
									onSubjectChange(subIndicator.id);
								}
								if (!isSimplifiedView) {
									e.preventDefault();
									onSubjectSelect(subIndicator.id);
								}
							}}
							href={`/measures/${subIndicator.id.toLowerCase()}.html`}
							className={`${
								isSearchedPhrase({
									subjectName: subIndicator.fullName,
									phrase: searchPhrase,
								})
									? styles.highlightSearchedWord
									: ''
							} ${
								!isSimplifiedView && selectedSubjects.includes(subIndicator.id)
									? `${subIndicatorsStyles.selected} ${subjectParent}`
									: ''
							} ${subIndicatorsStyles.subjectName}`}
						>
							<HighlightText text={subIndicator.fullName} phrase={searchPhrase} />
						</a>

						<span
							className={subIndicatorsStyles.appMenuLevel4Expand}
							style={subjectWithNoChildren ? { visibility: 'hidden' } : undefined}
						>
							{!nestedListsToShow.includes(subIndicator.id) ? (
								<span
									className={`${subIndicatorsStyles.expandButton} ${descendantsSelected ? subIndicatorsStyles.expandButtonActive : ''}`}
									onClick={() => {
										if (!subjectWithNoChildren) {
											showNestedLists((displayedRows) => [...displayedRows, subIndicator.id]);
										}
									}}
								>
									{/* eslint-disable-next-line i18next/no-literal-string */}
									{'+'}
								</span>
							) : (
								<span
									className={`${subIndicatorsStyles.expandButton} ${
										disableExpandButton ? indicatorsStyles.disabled : ''
									} ${descendantsSelected ? subIndicatorsStyles.expandButtonActive : ''}`}
									onClick={() => {
										if (disableExpandButton) {
											return;
										}
										showNestedLists((displayedRows) => displayedRows.filter((item) => item !== subIndicator.id));
									}}
								>
									<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M2.5 6H9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
									</svg>
								</span>
							)}
						</span>

						{subIndicator?.childrens ? (
							<SubSubIndicators
								subSubIndicators={subIndicator?.childrens}
								subIndicatorId={subIndicator.id}
								nestedListsToShow={nestedListsToShow}
								showNestedLists={showNestedLists}
								selectedSubjects={selectedSubjects}
								onSubjectSelect={onSubjectSelect}
								subjectColor={subjectColor}
								isSimplifiedView={isSimplifiedView}
								subjectParent={subjectParent}
								queryParams={queryParams}
								searchPhrase={searchPhrase}
								onSubjectChange={onSubjectChange}
							/>
						) : null}
					</li>
				);
			})}
		</ul>
	);
}
